import alpacaWebp from 'assets/avatars/alpaca.webp'
import alpacaPng from 'assets/avatars/alpaca.png'
import bearWebp from 'assets/avatars/bear.webp'
import bearPng from 'assets/avatars/bear.png'
import beaverWebp from 'assets/avatars/beaver.webp'
import beaverPng from 'assets/avatars/beaver.png'
import catWebp from 'assets/avatars/cat.webp'
import catPng from 'assets/avatars/cat.png'
import chameleonWebp from 'assets/avatars/chameleon.webp'
import chameleonPng from 'assets/avatars/chameleon.png'
import crocadillyWebp from 'assets/avatars/crocadilly.webp'
import crocadillyPng from 'assets/avatars/crocadilly.png'
import dogWebp from 'assets/avatars/dog.webp'
import dogPng from 'assets/avatars/dog.png'
import dolphinWebp from 'assets/avatars/dolphin.webp'
import dolphinPng from 'assets/avatars/dolphin.png'
import foxWebp from 'assets/avatars/fox.webp'
import foxPng from 'assets/avatars/fox.png'
import frogWebp from 'assets/avatars/frog.webp'
import frogPng from 'assets/avatars/frog.png'
import giraffeWebp from 'assets/avatars/giraffe.webp'
import giraffePng from 'assets/avatars/giraffe.png'
import hedgehogWebp from 'assets/avatars/hedgehog.webp'
import hedgehogPng from 'assets/avatars/hedgehog.png'
import koalaWebp from 'assets/avatars/koala.webp'
import koalaPng from 'assets/avatars/koala.png'
import lionWebp from 'assets/avatars/lion.webp'
import lionPng from 'assets/avatars/lion.png'
import monkeyWebp from 'assets/avatars/monkey.webp'
import monkeyPng from 'assets/avatars/monkey.png'
import otterWebp from 'assets/avatars/otter.webp'
import otterPng from 'assets/avatars/otter.png'
import owlWebp from 'assets/avatars/owl.webp'
import owlPng from 'assets/avatars/owl.png'
import pandaWebp from 'assets/avatars/panda.webp'
import pandaPng from 'assets/avatars/panda.png'
import parrotWebp from 'assets/avatars/parrot.webp'
import parrotPng from 'assets/avatars/parrot.png'
import penguinWebp from 'assets/avatars/penguin.webp'
import penguinPng from 'assets/avatars/penguin.png'
import raccoonWebp from 'assets/avatars/raccoon.webp'
import raccoonPng from 'assets/avatars/raccoon.png'
import redPandaWebp from 'assets/avatars/red_panda.webp'
import redPandaPng from 'assets/avatars/red_panda.png'
import sealWebp from 'assets/avatars/seal.webp'
import sealPng from 'assets/avatars/seal.png'
import slothWebp from 'assets/avatars/sloth.webp'
import slothPng from 'assets/avatars/sloth.png'
import squirrelWebp from 'assets/avatars/squirrel.webp'
import squirrelPng from 'assets/avatars/squirrel.png'
import tigerWebp from 'assets/avatars/tiger.webp'
import tigerPng from 'assets/avatars/tiger.png'
import turtleWebp from 'assets/avatars/turtle.webp'
import turtlePng from 'assets/avatars/turtle.png'
import whaleWebp from 'assets/avatars/whale.webp'
import whalePng from 'assets/avatars/whale.png'
import wolfWebp from 'assets/avatars/wolf.webp'
import wolfPng from 'assets/avatars/wolf.png'
import zebraWebp from 'assets/avatars/zebra.webp'
import zebraPng from 'assets/avatars/zebra.png'

/**
 * Bundler-imported animal avatars. Keys must match API AVATAR_KEYS.
 * Hashed URLs enable long-lived browser cache after first load.
 */
export const avatarRegistry = {
	alpaca: { webp: alpacaWebp, png: alpacaPng },
	bear: { webp: bearWebp, png: bearPng },
	beaver: { webp: beaverWebp, png: beaverPng },
	cat: { webp: catWebp, png: catPng },
	chameleon: { webp: chameleonWebp, png: chameleonPng },
	crocadilly: { webp: crocadillyWebp, png: crocadillyPng },
	dog: { webp: dogWebp, png: dogPng },
	dolphin: { webp: dolphinWebp, png: dolphinPng },
	fox: { webp: foxWebp, png: foxPng },
	frog: { webp: frogWebp, png: frogPng },
	giraffe: { webp: giraffeWebp, png: giraffePng },
	hedgehog: { webp: hedgehogWebp, png: hedgehogPng },
	koala: { webp: koalaWebp, png: koalaPng },
	lion: { webp: lionWebp, png: lionPng },
	monkey: { webp: monkeyWebp, png: monkeyPng },
	otter: { webp: otterWebp, png: otterPng },
	owl: { webp: owlWebp, png: owlPng },
	panda: { webp: pandaWebp, png: pandaPng },
	parrot: { webp: parrotWebp, png: parrotPng },
	penguin: { webp: penguinWebp, png: penguinPng },
	raccoon: { webp: raccoonWebp, png: raccoonPng },
	red_panda: { webp: redPandaWebp, png: redPandaPng },
	seal: { webp: sealWebp, png: sealPng },
	sloth: { webp: slothWebp, png: slothPng },
	squirrel: { webp: squirrelWebp, png: squirrelPng },
	tiger: { webp: tigerWebp, png: tigerPng },
	turtle: { webp: turtleWebp, png: turtlePng },
	whale: { webp: whaleWebp, png: whalePng },
	wolf: { webp: wolfWebp, png: wolfPng },
	zebra: { webp: zebraWebp, png: zebraPng },
}

export const getAvatarEntry = avatarKey => {
	if (!avatarKey) return null
	return avatarRegistry[avatarKey] || null
}

/** Stable order matching API AVATAR_KEYS whitelist. */
export const AVATAR_KEYS = Object.keys(avatarRegistry)
